"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTapeBuilderFromArtifactsDocument = exports.createTapeBuilder = void 0;
const common_1 = require("@finley-technologies/common");
const tape_sanitizer_1 = require("@finley-technologies/tape-sanitizer");
const convertor_1 = require("./convertor");
const dbNodes = __importStar(require("./dbNodes/dbNodes"));
const typeguards = __importStar(require("./typeguards"));
/**
 * create tape builder. Tape Builder provides interface to generate tapes and their definitions
 * given TapeBuilderTask and dependent tapes
 * @param {DbTable.ArtifactWithSlugs} artifacts - array of artifacts from the document.
 *  All the tape dependencies must be present in this map (except for raw tapes)
 * @returns {ITapeBuilder} tape builder interface
 */
const createTapeBuilder = (artifacts) => {
    // returns the artifact record for the given tape id
    const getTask = (id) => {
        const artifact = artifacts.find((record) => record.id === id);
        (0, common_1.finleyAssert)(artifact, `could not find tape with [artifactId:${id}]`);
        (0, common_1.finleyAssert)(typeguards.isTapeBuilderTask(artifact.configuration), `createTapeBuilder:tape configuration is not of task TapeBuilderTask: ${JSON.stringify(artifact.configuration)}`);
        return artifact.configuration;
    };
    const getIdFromSlug = (slug) => {
        const artifact = artifacts.find(({ artifactSlug }) => slug === artifactSlug);
        (0, common_1.finleyAssert)(artifact, `createTapeBuilder:could not find artifact with [artifactSlug:${slug}]`);
        return artifact.id;
    };
    const getSlugFromId = (id) => {
        const artifact = artifacts.find(({ id: artifactId }) => id === artifactId);
        (0, common_1.finleyAssert)(artifact, `createTapeBuilder:could not find artifact with [artifactId:${id}]`);
        return artifact.artifactSlug;
    };
    // `Transformation` is configuration for how tapes are 'sanitized' or 'edited' or 'joined'
    // these configuration include (a) input tape definitions and (b) operation specific parameters.
    // Tape builder has (b) in its TapeBuilderTask's. It generates (a) by walking back the dependency tree here.
    const convertTransformationOperation = ({ task, fieldDefinitionCallback, }) => {
        switch (task.operation) {
            case 'attachHeader': {
                const { srcArtifactSlug: _unused, ...restOfAttachHeaderParams } = task;
                return {
                    isValid: true,
                    data: {
                        srcDataTape: null,
                        ...restOfAttachHeaderParams,
                    },
                };
            }
            case 'unzip': {
                const { srcArtifactSlug: _unused, ...restOfAttachHeaderParams } = task;
                return {
                    isValid: true,
                    data: {
                        srcDataTape: null,
                        ...restOfAttachHeaderParams,
                    },
                };
            }
            case 'xlsx2csv': {
                const { srcArtifactSlug: _unused, ...restOfXlsx2CsvParams } = task;
                return {
                    isValid: true,
                    data: {
                        srcDataTape: null,
                        ...restOfXlsx2CsvParams,
                    },
                };
            }
            case 'xlsx2csv2': {
                const { srcArtifactSlug: _unused, ...restOfParams } = task;
                return {
                    isValid: true,
                    data: {
                        srcDataTape: null,
                        ...restOfParams,
                    },
                };
            }
            case 'pyXlsx2Csv2': {
                const { srcArtifactSlug: _unused, ...restOfParams } = task;
                return {
                    isValid: true,
                    data: {
                        srcDataTape: null,
                        ...restOfParams,
                    },
                };
            }
            case 'pyXlsxVirtualSheet2Csv': {
                const { srcArtifactSlug: _unused, ...restOfParams } = task;
                return {
                    isValid: true,
                    data: {
                        srcDataTape: null,
                        ...restOfParams,
                    },
                };
            }
            case 'pyCsvVirtualSheet': {
                const { srcArtifactSlug: _unused, ...restOfParams } = task;
                return {
                    isValid: true,
                    data: {
                        srcDataTape: null,
                        ...restOfParams,
                    },
                };
            }
            case 'pdf2csv': {
                const { srcArtifactSlug: _unused, ...restOfPdf2CsvParams } = task;
                return {
                    isValid: true,
                    data: {
                        srcDataTape: null,
                        ...restOfPdf2CsvParams,
                    },
                };
            }
            case 'preFilter': {
                const { srcArtifactSlug: _unused, ...restOfParams } = task;
                return {
                    isValid: true,
                    data: {
                        srcDataTape: null,
                        ...restOfParams,
                    },
                };
            }
            case 'asset2json': {
                const { srcArtifactSlug: _unused, ...restOfParams } = task;
                return {
                    isValid: true,
                    data: {
                        srcDataTape: null,
                        ...restOfParams,
                    },
                };
            }
            case 'sanitize': {
                const { baseFields, delimiter, doNotSanitizeFieldNames } = task;
                const sanitizeFieldNames = !doNotSanitizeFieldNames;
                return {
                    isValid: true,
                    data: {
                        operation: 'sanitize',
                        srcDataTape: {
                            baseFields,
                            delimiter,
                        },
                        sanitizeFieldNames,
                    },
                };
            }
            case 'filter': {
                const { operation, srcArtifactSlug, filterFormula } = task;
                const srcDataTape = fieldDefinitionCallback(srcArtifactSlug);
                if (!srcDataTape.isValid) {
                    return {
                        isValid: false,
                        errors: srcDataTape.errors,
                    };
                }
                (0, common_1.finleyAssert)(srcDataTape.data, 'TapeDefinition is null for filter operation inputs');
                return {
                    isValid: true,
                    data: {
                        operation,
                        srcDataTape: srcDataTape.data,
                        filterFormula,
                    },
                };
            }
            case 'join': {
                const { srcArtifactSlug, joinArtifactSlug, ...restOfJoinParams } = task;
                const srcDataTape = fieldDefinitionCallback(srcArtifactSlug);
                const joinDataTape = fieldDefinitionCallback(joinArtifactSlug);
                if (srcDataTape.isValid && joinDataTape.isValid) {
                    (0, common_1.finleyAssert)(srcDataTape.data && joinDataTape.data, 'TapeDefinition is null for join operation inputs ');
                    return {
                        isValid: true,
                        data: {
                            srcDataTape: srcDataTape.data,
                            joinDataTape: joinDataTape.data,
                            ...restOfJoinParams,
                        },
                    };
                }
                const errors = [];
                if (!srcDataTape.isValid) {
                    errors.push(...srcDataTape.errors);
                }
                if (!joinDataTape.isValid) {
                    errors.push(...joinDataTape.errors);
                }
                return {
                    isValid: false,
                    errors,
                };
            }
            case 'edit': {
                const { srcArtifactSlug, fieldModifications } = task;
                const srcDataTape = fieldDefinitionCallback(srcArtifactSlug);
                if (srcDataTape.isValid) {
                    (0, common_1.finleyAssert)(srcDataTape.data, 'TapeDefinition is null for edit operation inputs ');
                    return {
                        isValid: true,
                        data: {
                            operation: 'edit',
                            srcDataTape: srcDataTape.data,
                            fieldModifications,
                        },
                    };
                }
                return {
                    isValid: false,
                    errors: srcDataTape.errors,
                };
            }
            case 'flatten': {
                const { srcArtifactSlug, groupByField, aggregationFields } = task;
                const srcDataTape = fieldDefinitionCallback(srcArtifactSlug);
                if (srcDataTape.isValid) {
                    (0, common_1.finleyAssert)(srcDataTape.data, 'TapeDefinition is null for flatten operation inputs ');
                    return {
                        isValid: true,
                        data: {
                            operation: 'flatten',
                            srcDataTape: srcDataTape.data,
                            groupByField,
                            aggregationFields,
                        },
                    };
                }
                return {
                    isValid: false,
                    errors: srcDataTape.errors,
                };
            }
            case 'stack': {
                const { srcArtifactSlug, otherArtifactSlugs, ensureUniqueFields, } = task;
                const inputSlugs = [srcArtifactSlug, ...otherArtifactSlugs];
                const inputTapeDefinitionResults = inputSlugs.map((slug) => fieldDefinitionCallback(slug));
                const errors = [];
                const inputTapeDefinitions = inputTapeDefinitionResults.map((tape) => {
                    if (!tape.isValid) {
                        errors.push(...tape.errors);
                        return null;
                    }
                    if (!tape.data) {
                        errors.push('Stack operation requires sanitized tapes as inputs. Are you using the correct tapes?');
                        return null;
                    }
                    return tape.data;
                });
                if (errors.length) {
                    return {
                        isValid: false,
                        errors,
                    };
                }
                const validTapeDefinitions = inputTapeDefinitions.filter(common_1.typeguards.isNotNullOrUndefined);
                return {
                    isValid: true,
                    data: {
                        operation: 'stack',
                        srcDataTape: validTapeDefinitions[0],
                        otherDataTapes: validTapeDefinitions.slice(1),
                        ensureUniqueFields,
                    },
                };
            }
            case 'ai2Csv': {
                const { fields, srcArtifactSlug, baseFieldsTemplate, ...rest } = task;
                // if fields are explicitly specified, we don't need to input tape to have srcDataTape
                if (fields) {
                    return {
                        isValid: true,
                        data: {
                            srcDataTape: null,
                            baseFieldsTemplate,
                            fields,
                            ...rest,
                        },
                    };
                }
                if (baseFieldsTemplate) {
                    let baseFields;
                    switch (baseFieldsTemplate) {
                        case 'balanceSheet':
                        case 'incomeStatement':
                            baseFields = tape_sanitizer_1.FINANCIAL_STATEMENT_BASE_FIELDS;
                            break;
                        default:
                            throw (0, common_1.finleyAssertUnreachable)(baseFieldsTemplate);
                    }
                    return {
                        isValid: true,
                        data: {
                            srcDataTape: null,
                            baseFieldsTemplate,
                            fields: baseFields,
                            ...rest,
                        },
                    };
                }
                try {
                    const srcDataTape = fieldDefinitionCallback(srcArtifactSlug);
                    if (!srcDataTape.isValid) {
                        return {
                            isValid: false,
                            errors: srcDataTape.errors,
                        };
                    }
                    (0, common_1.finleyAssert)(srcDataTape.data, 'TapeDefinition is null for ai2Csv operation inputs');
                    return {
                        isValid: true,
                        data: {
                            srcDataTape: srcDataTape.data,
                            baseFieldsTemplate,
                            ...rest,
                        },
                    };
                }
                catch (err) {
                    // since ai2csv allows fields to be optionally configured,
                    // it is not guaranteed we will find upstream tape with fields defined.
                    // if we cannot a source tape with fields, we will get hit with an assert from typeguards.isTapeBuilderTask eventually
                    // this error is difficult to debug, so we will gracefully handle with the minimal information in the err
                    const message = (0, common_1.getErrorMessage)(err);
                    if (message.startsWith('createTapeBuilder:tape configuration is not of task TapeBuilderTask')) {
                        return {
                            isValid: false,
                            errors: [
                                'Unable to find source data tape with fields definition. You must specify fields on an upstream tape or the ai2Csv node.',
                            ],
                        };
                    }
                    throw err;
                }
            }
            default:
                (0, common_1.finleyAssertUnreachable)(task);
        }
        (0, common_1.finleyAssert)(false, 'should not reach here');
    };
    // generates tape definition (base fields) for the given artifact
    const generateTapeDefinition = (artifactId) => {
        const task = getTask(artifactId);
        // generateTapeDefinition and convertTransformationOperation
        // are mutually recursive functions, hence the callback
        const transformation = convertTransformationOperation({
            task,
            fieldDefinitionCallback: (tapeSlug) => generateTapeDefinition(getIdFromSlug(tapeSlug)),
        });
        if (!transformation.isValid) {
            return {
                isValid: false,
                errors: transformation.errors,
            };
        }
        if (!transformation.data) {
            // for tapes which has no definition associated.
            // e.g. xlsx2csv,
            return {
                isValid: true,
                data: null,
            };
        }
        const output = (0, tape_sanitizer_1.transformDataTapeDefinition)(transformation.data);
        if (output.isValid) {
            return {
                isValid: true,
                data: output.data,
            };
        }
        // decorate errors with the artifactSlug.
        const errors = output.errors.map((error) => `[artifactSlug:${getSlugFromId(artifactId)}]:${error.message}`);
        return {
            isValid: false,
            errors,
        };
    };
    const getTransformation = (artifactId) => {
        const task = getTask(artifactId);
        // convert configuration to tape-sanitizer transformation
        const transformation = convertTransformationOperation({
            task,
            fieldDefinitionCallback: (tapeSlug) => generateTapeDefinition(getIdFromSlug(tapeSlug)),
        });
        // we do not expect errors in transformation at the time
        // of generating tape, as these errors will be surfaced before
        // saving tape generation pipeline
        (0, common_1.finleyAssert)(transformation.isValid, `transformation is invalid: ${JSON.stringify(transformation)}`);
        return {
            transformation: transformation.data,
            srcArtifactSlug: task.srcArtifactSlug,
        };
    };
    const generateTape = async ({ artifactId, inputTapeBuffers, inputBufferExtensions, pdfExtractor, assetExtractor, pyXlsx2Csv2Extractor, pyXlsxVirtualSheet2CsvExtractor, pyCsvVirtualSheetExtractor, ai2CsvExtractor, csvParser, }) => {
        const task = getTask(artifactId);
        const getBufferExtension = (slug) => {
            const inputArtifactId = getIdFromSlug(slug);
            const extension = inputBufferExtensions?.get(inputArtifactId);
            return extension &&
                common_1.borrowingBasePipeline.isSupportedFileExtension(extension)
                ? extension
                : undefined;
        };
        const getBuffer = async (slug) => {
            const inputArtifactId = getIdFromSlug(slug);
            const buffer = inputTapeBuffers.get(inputArtifactId);
            // if the input buffer does not exist see if it can be created.
            // as long as leaf nodes needed for the target node are
            // provided we should be able to generate requested artifactId.
            if (!buffer) {
                const previousResult = await generateTape({
                    artifactId: inputArtifactId,
                    inputTapeBuffers,
                    inputBufferExtensions,
                    pdfExtractor,
                    assetExtractor,
                    pyXlsx2Csv2Extractor,
                    pyXlsxVirtualSheet2CsvExtractor,
                    pyCsvVirtualSheetExtractor,
                    ai2CsvExtractor,
                    csvParser,
                });
                return previousResult;
            }
            (0, common_1.finleyAssert)(buffer, `could not find/generate buffer for [artifactSlug:${slug}]`);
            return {
                isValid: true,
                data: {
                    outputBuffer: buffer,
                },
                supplementals: [],
            };
        };
        // this function returns operation specific slugs
        // for which we need to get buffers
        // (besides srcArtifactSlug)
        // TODO: move this operation specific folder uinodes/operations/xxx/converter.ts
        const getInputSlugs = () => {
            switch (task.operation) {
                case 'stack':
                    return [task.srcArtifactSlug, ...task.otherArtifactSlugs];
                case 'join':
                    return [task.srcArtifactSlug, task.joinArtifactSlug];
                default:
                    return [task.srcArtifactSlug];
            }
        };
        const inputSlugs = getInputSlugs();
        const buffersWithExtensions = [];
        // collect buffers for all the inputs
        for (const inputSlug of inputSlugs) {
            // eslint-disable-next-line no-await-in-loop
            const dataTapeOutput = await getBuffer(inputSlug);
            if (dataTapeOutput.isValid) {
                buffersWithExtensions.push({
                    buffer: dataTapeOutput.data.outputBuffer,
                    extension: getBufferExtension(inputSlug),
                });
            }
            else {
                // return on any failure to get the buffer.
                return dataTapeOutput;
            }
        }
        const output = await (0, tape_sanitizer_1.transformDataTape)({
            transformation: getTransformation(artifactId).transformation,
            buffersWithExtensions,
            pdfExtractor,
            assetExtractor,
            pyXlsx2Csv2Extractor,
            pyXlsxVirtualSheet2CsvExtractor,
            pyCsvVirtualSheetExtractor,
            ai2CsvExtractor,
            csvParser,
        });
        return output;
    };
    const getGeneratedLoanTapeConfig = (artifactId) => {
        // we assume that the artifact is a generatedLoanTape
        const artifact = artifacts.find(({ id }) => id === artifactId);
        (0, common_1.finleyAssert)(typeguards.isTapeBuilderRecordUI(artifact), 'not a tapeBuilder record');
        (0, common_1.finleyAssert)(dbNodes.generatedLoanTape.typeGuard(artifact), 'not a loan tape');
        return artifact.configuration;
    };
    const generateTapeDefinitionBySlug = (artifactSlug) => {
        return generateTapeDefinition(getIdFromSlug(artifactSlug));
    };
    return {
        generateTapeDefinition,
        generateTapeDefinitionBySlug,
        generateTape,
        getGeneratedLoanTapeConfig,
        getTransformation,
    };
};
exports.createTapeBuilder = createTapeBuilder;
const createTapeBuilderFromArtifactsDocument = (artifactsDocument) => {
    const { dataTapes } = convertor_1.convertor.dbRecordsFromArtifactsDocument({
        artifactsDocument,
    });
    return (0, exports.createTapeBuilder)(dataTapes);
};
exports.createTapeBuilderFromArtifactsDocument = createTapeBuilderFromArtifactsDocument;
//# sourceMappingURL=tapeBuilder.js.map